import { useNotepad } from '../contexts/NotepadContext';

/**
 * Compact "which notebook do new clips go to?" picker. Renders nothing when
 * there's 0–1 notebook (no choice to make). Bound to the active notebook, so
 * it stays in sync with the drawer tabs — capturing a clip files it here.
 *
 * Drop it next to a capture control (the viewer "Clip to notepad" button, the
 * chat "Save to notepad" button).
 */
export default function NotebookDestinationSelect({ className }) {
  const np = useNotepad();
  if (!np || (np.notebooks?.length || 0) < 2) return null;
  return (
    <label
      className={`np-dest-select ${className || ''}`.trim()}
      title="Which notebook new clips are saved to"
    >
      {/* Visible words, not just an arrow — "→ Original" read as an unlabeled
          mystery; the dropdown holds NOTEBOOK names a novice can't recognize. */}
      <span className="np-dest-label">Save to</span>
      <select
        value={np.activeNotebookId || ''}
        onChange={(e) => np.setActiveNotebook(e.target.value)}
        aria-label="Destination notebook for new clips"
      >
        {np.notebooks.map(nb => (
          <option key={nb.id} value={nb.id}>{nb.name}</option>
        ))}
      </select>
    </label>
  );
}
